import { Row, Col } from "react-bootstrap";
import FormGroupTile from "components/core/basic/FormGroupTile";
import { useFetch } from "hooks/api";

const BulkAdPlanRulesForm = ({ formData, setFormData }) => {
  const { data: biddingProgramData } = useFetch(
    ["programs", "bidding"],
    "/programs",
    { engine: "bidding" },
    {
      select: (data) => {
        return data.data?.results;
      },
    },
  );

  const bidProgramOptions =
    biddingProgramData?.map((program) => {
      return { value: program.id, label: program.name };
    }) ?? [];

  bidProgramOptions.unshift({ value: null, label: "No Bidding Rules" });

  const handleChange = (key, value) => {
    setFormData({ ...formData, [key]: value });
  };

  return (
    <Row className="pb-5">
      <form onSubmit={(e) => e.preventDefault()}>
        <Row className="d-flex justify-content-center align-items-center">
          <p className="pb-4 fs-4 w-75">Please select bidding rules to apply to the selected media plans.</p>
          <Col xs={12} md={6} lg={4} className="px-5">
            <FormGroupTile
              label={"Bidding Rules"}
              type="select"
              multi={false}
              stateName={"biddingProgram"}
              handleChildFormElement={(key, value) => {
                handleChange(key, value.value);
              }}
              defaultValue={bidProgramOptions?.find((program) => program.value === formData.biddingProgram)}
              options={bidProgramOptions}
            />
          </Col>
        </Row>
      </form>
    </Row>
  );
};

export default BulkAdPlanRulesForm;
